import React from "react";
// hook
import { useStyles } from "../hooks/table.useStyles";
// language
import { useLocale } from "../../../modules/hooks/UseLocale";
// UI
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Button from "@material-ui/core/Button";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
// constants
import { TabKey } from "../MasterMaintenance.constants";
// method
import { setSortData } from "../methods/common.methods";

export const MasterMaintenanceServiceCenterTbody = (props: any) => {
  const { pageInfo, order, orderBy } = props;
  const classes = useStyles();
  const { t } = useLocale({
    defaultPath: "modules.components.MasterMaintenance.serviceCenter",
  });

  return (
    <TableBody>
      {setSortData(props.data, order, orderBy)
        .slice(
          pageInfo.page * pageInfo.rowsPerPage,
          pageInfo.page * pageInfo.rowsPerPage + pageInfo.rowsPerPage
        )
        .map((row: any, index: number) => {
          return (
            <TableRow className={classes.tbody} hover tabIndex={-1} key={index}>
              <TableCell className={classes.nowrap}>
                {row.service_center_id}
              </TableCell>
              <TableCell className={classes.nowrap}>{row.name}</TableCell>
              <TableCell className={classes.nowrap}>{row.address_1}</TableCell>
              <TableCell className={classes.nowrap}>{row.address_2}</TableCell>
              <TableCell className={classes.nowrap}>{row.address_3}</TableCell>
              <TableCell className={classes.nowrap}>{row.country}</TableCell>
              <TableCell className={classes.nowrap}>{row.state_cd}</TableCell>
              <TableCell className={classes.nowrap}>{row.postal_cd}</TableCell>
              <TableCell className={classes.nowrap}>
                {row.facility_cd}
              </TableCell>
              <TableCell className={classes.nowrap}>{row.warehouse}</TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<EditIcon />}
                  onClick={() => props.handleEdit(row, TabKey.serviceCenter)}
                >
                  {t("edit")}
                </Button>
              </TableCell>
              <TableCell>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<DeleteIcon />}
                  onClick={() => props.handleDelete(row)}
                >
                  {t("delete")}
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
    </TableBody>
  );
};
